import {
  userRoles,
  UserRoleTypes,
} from '../../../../../../../../../shared/constants/userRoles';

type DescriptionInfo = {
  title: string;
  description: string;
};

export const getDescriptionInfo = (role: UserRoleTypes): DescriptionInfo => {
  const entityInfo = {
    title: 'Generate a new password and send it using various methods',
    description: `Generate a password without logging out. 
    The next time you log into the platform, please use the new password`,
  };

  const adminInfo = {
    title: 'Generate a new password and send it using various methods',
    description: `Instead of the user, you can generate a new password and provide it to them. 
        Then user will use this password during the login process`,
  };

  switch (role) {
    case userRoles.SUPERUSER:
    case userRoles.INBODY_ADMIN:
      return adminInfo;
    default:
      return entityInfo;
  }
};
